/* Velumbra · scripts propios (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vl-reveal:not(.vl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('vl-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('vl-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-vl-galeria]').forEach(function (g) {
      var main = g.querySelector('[data-vl-principal]');
      if (!main) return;
      g.querySelectorAll('[data-vl-mini]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = b.getAttribute('data-src');
            main.srcset = b.getAttribute('data-srcset') || '';
            main.alt = b.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
          g.querySelectorAll('[data-vl-mini]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var miles = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComa = miles + ',' + parts[1];
    var conPunto = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    fmt = fmt || '{{amount_with_comma_separator}} €';
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa).replace(/\{\{\s*amount\s*\}\}/, conPunto).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles);
  }

  function initVariantes() {
    document.querySelectorAll('[data-vl-producto]').forEach(function (root) {
      var dataEl = root.querySelector('[data-vl-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var fmt = root.getAttribute('data-formato');
      var inputs = root.querySelectorAll('[data-vl-opcion]');
      if (!inputs.length) return;
      function actualizar() {
        var sel = [];
        root.querySelectorAll('[data-vl-grupo]').forEach(function (grp) {
          var c = grp.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        var idInput = root.querySelector('input[name="id"]');
        var btn = root.querySelector('[data-vl-boton]');
        var precio = root.querySelector('[data-vl-precio]');
        var tachado = root.querySelector('[data-vl-tachado]');
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-no-disponible'); } return; }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = formatMoney(v.price, fmt);
        if (tachado) { tachado.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, fmt) : ''; }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-texto') : btn.getAttribute('data-agotado'); }
        if (v.featured_media && v.featured_media.preview_image) {
          var main = root.querySelector('[data-vl-principal]');
          if (main) { main.src = v.featured_media.preview_image.src + '&width=1400'; main.srcset = ''; }
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      inputs.forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initBarraCompra() {
    var barra = document.querySelector('[data-vl-barra]');
    var objetivo = document.querySelector('[data-vl-boton]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      barra.classList.toggle('vl-activa', fuera);
    });
    io.observe(objetivo);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () { objetivo.click(); });
  }

  function initParallax() {
    if (reduce) return;
    var el = document.querySelectorAll('[data-vl-parallax]');
    if (!el.length) return;
    var tick = false;
    function mover() {
      el.forEach(function (e) {
        var f = parseFloat(e.getAttribute('data-vl-parallax')) || 0;
        var r = e.getBoundingClientRect();
        var d = (r.top + r.height / 2 - window.innerHeight / 2) * f / 100;
        e.style.transform = 'translate3d(0,' + (-d).toFixed(1) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(mover); } }, { passive: true });
    mover();
  }

  function init() { initReveal(); initGaleria(); initVariantes(); initBarraCompra(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
